import * as React from 'react';

import {Modal} from 'shells/modal/modal';

import type {CalendarSync} from 'nutshell-graphql-types';

import {EmailCalendarSyncCompletionPage} from './email-calendar-sync-completion-page';
import type {EmailCalendarSyncSettings} from './email-calendar-sync-settings-page';
import {EmailCalendarSyncSettingsPage} from './email-calendar-sync-settings-page';

type Page = 'sync-settings' | 'completion';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onSaveSyncSettings: (settings: EmailCalendarSyncSettings) => Promise<void>;
    calendarSync: CalendarSync | null;
};

export function EmailCalendarSyncModal(props: Props) {
    const [currentPage, setCurrentPage] = React.useState<Page>('sync-settings');

    let content = null;
    if (currentPage === 'sync-settings') {
        content = (
            <EmailCalendarSyncSettingsPage
                onSave={props.onSaveSyncSettings}
                onSaveSuccess={() => {
                    setCurrentPage('completion');
                }}
                calendarSync={props.calendarSync}
            />
        );
    } else if (currentPage === 'completion') {
        content = <EmailCalendarSyncCompletionPage onClose={props.onClose} />;
    }

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            fitHeight={true}
            maxWidth={700}
            noPadding={true}
            canClickOutsideToClose={false}
            canEscapeToClose={false}
        >
            {content}
        </Modal>
    );
}
